<ng-container *ngIf="packageId; else showProduct">
  <mat-card appearance="outlined" class="custom-price-card">
    <mat-card-header>
      <glxy-avatar mat-card-avatar [name]="packageName" [src]="packageIconUrl"></glxy-avatar>
      <mat-card-title>{{ packageName }}</mat-card-title>
      <mat-card-subtitle>{{ item.sharedMarketingInformation?.name }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <ng-container *ngIf="editable; else readonly">
        <p>Enter the amount you'll spend each billing period.</p>
      </ng-container>
      <ng-template #readonly>
        <p>The amount that was set to spend</p>
      </ng-template>
      <ng-container *ngIf="appPrice">
        <billing-ui-variable-price-input
          (spendAmountChanged)="changeSpendAmount($event)"
          [appPrice]="appPrice"
          [currentSpendAmount]="customValue"
          [currencyCode]="partnerCurrency"
          [disabled]="!editable"
        ></billing-ui-variable-price-input>
      </ng-container>
    </mat-card-content>
  </mat-card>
</ng-container>
<ng-template #showProduct>
  <mat-card appearance="outlined" class="custom-price-card">
    <mat-card-header>
      <glxy-avatar
        mat-card-avatar
        [name]="item.sharedMarketingInformation?.name"
        [src]="item.sharedMarketingInformation?.iconUrl"
      ></glxy-avatar>
      <mat-card-title style="padding-top: 8px">{{ item.sharedMarketingInformation?.name }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <ng-container *ngIf="editable; else readonly">
        <p>Enter the amount you'll spend each billing period.</p>
      </ng-container>
      <ng-template #readonly>
        <p>The amount that was set to spend</p>
      </ng-template>
      <ng-container *ngIf="appPrice">
        <billing-ui-variable-price-input
          (spendAmountChanged)="changeSpendAmount($event)"
          [appPrice]="appPrice"
          [currentSpendAmount]="customValue"
          [currencyCode]="partnerCurrency"
          [disabled]="!editable"
        ></billing-ui-variable-price-input>
      </ng-container>
    </mat-card-content>
  </mat-card>
</ng-template>
